import { render, staticRenderFns } from "./ProductCreate.vue?vue&type=template&id=25dc0b13&scoped=true"
import script from "./ProductCreate.vue?vue&type=script&lang=js"
export * from "./ProductCreate.vue?vue&type=script&lang=js"
import style0 from "./ProductCreate.vue?vue&type=style&index=0&id=25dc0b13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc0b13",
  null
  
)

export default component.exports